/**
 * Enum representing the different types of task attachments used
 * If a new non-previewable type is added, please add it to the NonPreviewableSupportedFileTypes array.
 */ export var SupportedReferenceTypes = /*#__PURE__*/ function(SupportedReferenceTypes) {
    SupportedReferenceTypes["Word"] = "Word";
    SupportedReferenceTypes["Excel"] = "Excel";
    SupportedReferenceTypes["PowerPoint"] = "PowerPoint";
    SupportedReferenceTypes["OneNote"] = "OneNote";
    SupportedReferenceTypes["Project"] = "Project";
    SupportedReferenceTypes["Visio"] = "Visio";
    SupportedReferenceTypes["Pdf"] = "Pdf";
    SupportedReferenceTypes["Loop"] = "Loop";
    SupportedReferenceTypes["Form"] = "Form";
    SupportedReferenceTypes["TeamsHostedApp"] = "TeamsHostedApp";
    SupportedReferenceTypes["Other"] = "Other";
    return SupportedReferenceTypes;
}({});
/** Subset of SupportedReferenceTypes that are non-previewables */ export const NonPreviewableSupportedFileTypes = [
    "OneNote",
    "Project",
    "Visio",
    "Form"
];
/** These are types that have preview, so if the taskAttachmentType is "Other" we will only fetch preview if the attachment is one of this. */ export const FileTypesWithPreview = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp"
];
